import { all } from 'redux-saga/effects';
import getPaymentDue from './getPaymentDue';
import getInitialPaymentDue from './getInitialPaymentDue';
import getPaymentUrlFromEPF from './getPaymentUrlFromEPF';
import getPaymentInquiryFromEPF from './getPaymentInquiryFromEPF';
import getCubePaymentDue from './getCubePaymentDue';

export const paymentSagas = function* root() {
  yield all([
    getPaymentDue(),
    getInitialPaymentDue(),
    getCubePaymentDue(),
    getPaymentUrlFromEPF(),
    getPaymentInquiryFromEPF(),
  ]);
};
